import { CompanyLinked } from "./../models/companylinked";
import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { GLOBAL } from "./global";
import { AnyCatcher } from "rxjs/internal/AnyCatcher";

@Injectable({
  providedIn: "root",
})
export class LocationService {
  public url: string;

  constructor(private _http: HttpClient) {
    this.url = GLOBAL.url;
  }

  getLocations(token,
    page?: any,
    perPage?: any,
    filtros: any[] = [],
    task?: any
  ): Observable<any> {

     task = task ?? [];
     const json = JSON.stringify(task);

    const params = `json=${encodeURIComponent(json)}&authorization=${token}`;
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

      page = page ?? 1;
      perPage = perPage ?? 10;
    
        let queryParams = `?page=${page}&perpage=${perPage}`;
        filtros.forEach(filtro => {
          if (filtro && filtro.value) {
            queryParams += `&${filtro.key}=${encodeURIComponent(filtro.value)}`;
            if (filtro.key_type) {
              queryParams += `&${filtro.key_type}=${encodeURIComponent(filtro.type)}`;
            }
          }
        });


    return this._http.post<any>(`${this.url}/location/list${queryParams}`, params, {
      headers,
    });
  }

  getAvailables(token, id, location): Observable<any> {
    let json = JSON.stringify(location);
    json = encodeURIComponent(json);
    const params = `json=${json}&authorization=${token}`;
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });
    const page = 1;

    return this._http.post<any>(
      `${this.url}/internallocation/locationavailables/${id}`,
      params,
      { headers }
    );
  }

  getLocationsByCompany(token, id): Observable<any> {
    const params = `authorization=${token}`;
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

    return this._http.post<any>(
      `${this.url}/location/listbycompany/${id}?page=1`,
      params,
      { headers }
    );
  }

  addDateCertificate(
    token: any,
    id: any,
    endDate: any,
    startDate: any,
    active: any,
    type: any
  ): Observable<any> {
    let params =
      "id=" +
      id +
      "&endDate=" +
      endDate +
      "&startDate=" +
      startDate +
      "&active=" +
      active +
      "&type=" +
      type +
      "&authorization=" +
      token;
    let headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

    return this._http
      .post<any>(this.url + "/company/changedatecertificate", params, {
        headers: headers,
      })
      .pipe(map((res) => res));
  }

  getGeneralLocations(token, wh_id, ids): Observable<any> {
    let json = JSON.stringify(ids);
    json = encodeURIComponent(json);
    const params = `json=${json}&authorization=${token}`;
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

    return this._http.post<any>(
      `${this.url}/internallocation/onlylinkedlocations/${wh_id}?page=1`,
      params,
      { headers }
    );
  }

  getLocationsByWareHoue(token, id): Observable<any> {
    const params = `authorization=${token}`;
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

    return this._http.post<any>(
      `${this.url}/internallocation/locationavailablesnoweights/${id}?page=1`,
      params,
      { headers }
    );
  }

  getLocationsavailablesstocksByWareHoue(token, id): Observable<any> {
    const params = `authorization=${token}`;
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

    return this._http.post<any>(
      `${this.url}/internallocation/locationavailablesstocksnoweights/${id}?page=1`,
      params,
      { headers }
    );
  }

  getLocationsByUser(token, id): Observable<any> {
    const params = `authorization=${token}`;
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

    return this._http.post<any>(
      `${this.url}/location/listbyuser/${id}?page=1`,
      params,
      { headers }
    );
  }

  getContainers(token): Observable<any> {
    const params = `authorization=${token}`;
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

    return this._http.post<any>(
      `${this.url}/weightitem/listbylocation/INVENTORIES?perpage=100000`,
      params,
      { headers }
    );
  }

  getContainersInput(token): Observable<any> {
    const params = `authorization=${token}`;
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

    return this._http.post<any>(
      `${this.url}/weightitem/listbylocationinput/INVENTORIES?perpage=100000`,
      params,
      { headers }
    );
  }

  saveContainers(token, container_id, task): Observable<any> {
    let json = JSON.stringify(task);
    json = encodeURIComponent(json);
    const params = `json=${json}&authorization=${token}`;
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

    return this._http.post<any>(
      `${this.url}/inventory/especificedit/${container_id}`,
      params,
      { headers }
    );
  }

  getConditions(token): Observable<any> {
    const params = `authorization=${token}`;
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

    return this._http.post<any>(`${this.url}/condition/list?page=1`, params, {
      headers,
    });
  }

  getCurrencies(
    token,
    activo?: any,
    page?: any,
    perPage?: any,
    filtros: any[] = [],
    order?: any
  ): Observable<any> {

        order = order ?? [];

        const json = JSON.stringify(order);

         let params = `authorization=${token}`;

          if (order) {
            params += `&order=${encodeURIComponent(json)}`;
          }
          
          if (activo) {
            params += `&activo=${encodeURIComponent(JSON.stringify(activo))}`;
          }
          
        
        let headers = new HttpHeaders({
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-Requested-With': 'XMLHttpRequest'
        });
   
        page = page ?? 1;
        perPage = perPage ?? 10;
    
        let queryParams = `?page=${page}&perpage=${perPage}`;
        filtros.forEach(filtro => {
          if (filtro && filtro.value) {
            queryParams += `&${filtro.key}=${encodeURIComponent(filtro.value)}`;
            if (filtro.key_type) {
              queryParams += `&${filtro.key_type}=${encodeURIComponent(filtro.type)}`;
            }
          }
        });
    

     return this._http.post<any>(
      `${this.url}/currency/list${queryParams}`,
      params,
      { headers: headers }
    ).pipe(
      map((res: any) => res)
    );

    /*
    return this._http.post<any>(`${this.url}/currency/list?page=1`, params, {
      headers,
    });
    */
  }

  editCurrency(
    token,
    name: any,
    id: any,
    symbol: any,
    message: any,
    defaultCurrency
  ): Observable<any> {
    let currency = {
      name: name,
      symbol: symbol,
      message: message,
      defaultCurrency: defaultCurrency,
    };
    const json = JSON.stringify(currency);
    const params = `json=${encodeURIComponent(json)}&authorization=${token}`;
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });
    if (id !== null) {
      return this._http.post<any>(`${this.url}/currency/edit/${id}`, params, {
        headers,
      });
    } else {
      return this._http.post<any>(`${this.url}/currency/new`, params, {
        headers,
      });
    }
  }

  deleteCurrency(token, id?: any, active?: any, masive?: any): Observable<any> {

     let params = `authorization=${token}`;

          if (active) {
            params += `&activo=${encodeURIComponent(JSON.stringify(active))}`;
          }

        if(masive){
          params += `&masive=${encodeURIComponent(JSON.stringify(masive))}`;
        }

    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

     const page = 1;    

    return this._http
      .post(`${this.url}/currency/remove/${id}?page=${page}`, params, {
        headers: headers,
      })
      .pipe(map((res) => res));
  }

  newLocation(token, location): Observable<any> {
    let json = JSON.stringify(location);
    json = encodeURIComponent(json);
    const params = `json=${json}&authorization=${token}`;
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });
    const page = 1;

    return this._http.post<any>(
      `${this.url}/location/new?page=${page}`,
      params,
      { headers }
    );
  }

  editLocation(token, id, location): Observable<any> {
    let json = JSON.stringify(location);
    json = encodeURIComponent(json);
    const params = `json=${json}&authorization=${token}`;
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });
    const page = 1;

    return this._http.post<any>(
      `${this.url}/location/edit/${id}?page=${page}`,
      params,
      { headers }
    );
  }

  delete(token, id): Observable<any> {
    const params = `authorization=${token}`;
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });
    const page = 1;

    return this._http.post<any>(
      `${this.url}/location/remove/${id}?page=${page}`,
      params,
      { headers }
    );
  }
  deleteBulk(token, data): Observable<any> {
    const json = JSON.stringify(data);
    const params = `json=${json}&authorization=${token}`;
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });
    const page = 1;

    return this._http.post<any>(`${this.url}/location/bulkremove`, params, {
      headers,
    });
  }

  getLocation(token, id): Observable<any> {
    const params = `authorization=${token}`;
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });
    const page = 1;

    return this._http.post<any>(
      `${this.url}/location/detail/${id}?page=${page}`,
      params,
      { headers }
    );
  }
}
